/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { FirebaseMessaging } from "./firebase.js";

// register('OneSignalSDKWorker.js')


if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(registration) {
      FirebaseMessaging.initServiceWorker(registration);
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      // document.dispatchEvent(
      //   new CustomEvent('serviceWorkerRegisterEvent', { detail: registration })
    // );
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')

      document.dispatchEvent(
        new CustomEvent('serviceWorkerUpdateEvent', { detail: registration })
    );

      // console.log(registration)
      // if (registration.waiting.scriptURL.includes("OneSignal")){
      //   console.log("OneSignal Registered")
      //   return
      // }
      // let confirmationResult = confirm("Existe una versión de la aplicación, ¿desea actualizar?")
      // if (confirmationResult) registration.waiting.postMessage({action: "skipWaiting"})
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  let refreshing
  navigator.serviceWorker.addEventListener("controllerchange", e=>{
    if (refreshing) return
    window.location.reload()
    refreshing = true
  })
}
